import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-rightsidebar',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './rightsidebar.component.html',
  styleUrl: './rightsidebar.component.scss'
})
export class RightsidebarComponent {
   @Input() expanded: boolean = true;

   constructor(private router: Router){

   }

  menuList: any[] = [
    {
      route: 'dashboard',
      img: 'assets/icons/Graph.png',
      title: 'Dashboard',
    },
    {
      route: 'KYC',
      img: 'assets/icons/Kyc.png',
      title: 'KYC',
    },
    {
      route: 'users',
      img: 'assets/icons/profile-circle.png',
      title: 'Accounts',
    },
    {
      route: 'alert',
      img: 'assets/icons/alert.png',
      title: 'Alert',
    },
    {
      route: 'On demand',
      img: 'assets/icons/On demand.png',
      title: 'One Demand Screening',
    },
    {
      route: 'Inquiries',
      img: 'assets/icons/Inquiries.png',
      title: 'Inquiry',
    },
    {
      route: 'message-alert',
      img: 'assets/icons/message-alert.png',
      title: 'Task',
    },
    {
      route: 'FATCA',
      img: 'assets/icons/FATCA.png',
      title: 'System Report',
    },
    {
      route: 'Regulatory Report',
      img: 'assets/icons/Regulatory Report.png',
      title: 'Regualatory Report',
    },
    {
      route: 'FATCA',
      img: 'assets/icons/FATCA.png',
      title: 'FATCA Reportin',
    },
    {
      route: 'Analytics',
      img: 'assets/icons/Analytics.png',
      title: 'Analaystic',
    },
    {
      route: 'Audit Trail',
      img: 'assets/icons/Audit Trail.png',
      title: 'Audit Trail',
    },
    {
      route: 'Workflow-landinglist',
      img: 'assets/icons/Workflow.png',
      title: 'Work Flow',
    },
    {
      route: 'landing-list',
      img: 'assets/icons/rule-manage.png',
      title: 'Case Management',
    },
    {
      route: 'rule-management',
      img: 'assets/icons/rule-manage.png',
      title: 'Rule Management',
    },
    {
      route: 'user',
      img: 'assets/icons/user.png',
      title: 'User Management',
    },
    {
      route: 'carbon_settings',
      img: 'assets/icons/carbon_settings.png',
      title: 'Configuration',
    },
    {
      route: 'Watchlist',
      img: 'assets/icons/Watchlist.png',
      title: 'Watching Managment List',
    },
  ];

  isActive(route: string): boolean {
    return this.router.url.includes(route);
  }
}
